/** The cart drawer's default block order — a LEAF module, on purpose.
 *
 *  This is the same lesson as `shadows.ts` and `MAX_BLOCK_DEPTH`, one step
 *  further. The storefront's cart drawer needs this list in its ENTRY chunk
 *  (`lib/cartblockhost.ts` falls back to it when a theme carries no `main-cart`
 *  section), and it reaches it through the package barrel. While the list lived
 *  in `sections/main-cart.ts`, that import pulled the whole module in — and
 *  Rollup keeps the `defineSection({...})` call assigned to the exported
 *  `mainCart` const, which drags in `buttonStyleFields` and its ~115 lines of
 *  builder-only field declarations. Measured on the entry chunk: the strings
 *  "Follow theme settings", "Corner radius", "Border width" and "Show this
 *  button" were all shipped to every shopper, for a control that only ever
 *  renders inside the dashboard's theme builder.
 *
 *  So the list lives here, in a module with no other imports, and
 *  `sections/main-cart.ts` reads it FROM here to build its presets — the two
 *  still cannot drift, which was the point of the previous refactor, and the
 *  section definition is now genuinely unreachable from the entry.
 *
 *  Do NOT import anything into this file. Its whole value is being a leaf.
 */
/** The drawer's block order, as bare types — the section's presets AND the
 *  storefront's no-section fallback, from one array so they cannot drift. */
export const PRESET_BLOCKS = [
    "countdown",
    "progress-bar",
    "line-items",
    "note",
    "discount",
    "savings",
    "subtotal",
    // Between the subtotal and the button, which is where every implementation of
    // this pattern puts it: the shopper has just read what they owe and has not
    // yet committed. Safe in the preset — and therefore in every theme authored
    // before it existed — because it renders nothing until a seller picks a
    // product. This is where the old `add-ons` block sat; the old `upsells` block
    // sat above the note, and the merged block takes the stronger position.
    "product-upsell",
    "checkout-button",
    "trust-badges",
];
/** Block order the drawer renders when the theme carries no `main-cart`
 *  section — i.e. every theme authored before Phase 4. Reproduces the previous
 *  hard-coded drawer, so un-migrated stores are unaffected. */
export function defaultMainCartBlocks() {
    return [...PRESET_BLOCKS];
}
//# sourceMappingURL=main-cart-presets.js.map